export const provinces = [
    { code: 'AB', province: 'Alberta' },
    { code: 'BC', province: 'British Columbia' },
    { code: 'MB', province: 'Manitoba' },
    { code: 'ON', province: 'Ontario' },
    { code: 'NS', province: 'Nova Scotia' },
    { code: 'NL', province: 'Newfoundland & Labrador' },
    { code: 'NB', province: 'New Brunswick' },
    { code: 'NT', province: 'Northwest Territories' },
    { code: 'NU', province: 'Nunavut' },
    { code: 'PE', province: 'Prince Edward Island' },
    { code: 'SK', province: 'Saskatchewan' },
    { code: 'QC', province: 'Quebec' },
    { code: 'YT', province: 'Yukon Territory' }
]

export const getProvince = (province) => {
    return provinces.find(item => item.province === province)
}